import { render, staticRenderFns } from "./Attach.vue?vue&type=template&id=3d8fb65e&v-on-clickaway=cancel&"
import script from "./Attach.vue?vue&type=script&lang=ts&"
export * from "./Attach.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports